import { every, findIndex, isEmpty } from 'lodash';

import * as types from './constants';
import { sorts } from '../../../pages/Gifts/GiftsList/components/LookbooksTab/sort';
import { generateQueryFromString, removeFromQueryString } from '../../../utils/queryString';
import queryString from 'query-string';


export const initialState = {
  dataTable: [],
  allSelected: false,
  loading: false,
  count: 0,
  next: null,
  previous: null,
  curr_page: 1,
  errors_api: {},
  queryParsed: false,
  message: null,
  filters: [
    { key: 'sort', filterTitle: 'Sort', selected: true, value: sorts.default }
    // { key: 'status', filterTitle: 'Status', selected: false, value: null },
    // { key: 'created_by_split', filterTitle: 'Created in Split', selected: false, value: null }
  ]
};

const actions = {
  // Get My Creators
  [types.GET_LOOKBOOKS_REQUEST]: state => {
    const data = {
      ...state,
      dataTable: [],
      loading: true
    };

    return { ...data };
  },

  [types.GET_LOOKBOOKS_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      ...payload
    };

    return { ...data };
  },

  [types.GET_LOOKBOOKS_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      errors_api: payload
    };

    return { ...data };
  },

  [types.GET_LOOKBOOKS_RESET]: () => {
    return { ...initialState };
  },

  // Operations
  [types.TOGGLE_LOOKBOOK]: (state, { payload }) => {
    const newDataTable = state.dataTable.map(el => el.select.id === payload ? {
      ...el,
      select: { ...el.select, value: !el.select.value }
    } : el);

    const status = every(newDataTable, x => x.select.value);

    const data = {
      ...state,
      allSelected: status,
      dataTable: newDataTable
    };

    return { ...data };
  },

  [types.TOGGLE_ALL_LOOKBOOKS]: (state, { payload }) => {

    if (payload && payload.reset) {
      const data = {
        ...state,
        allSelected: false,
        dataTable: state.dataTable.map(el => ({
          ...el,
          select: { ...el.select, value: false }
        }))
      };

      return { ...data };
    } else {
      const status = every(state.dataTable, x => x.select.value);

      const data = {
        ...state,
        allSelected: !status,
        dataTable: state.dataTable.map(el => ({
          ...el,
          select: { ...el.select, value: !status }
        }))
      };

      return { ...data };
    }
  },

  [types.SET_LOOKBOOKS_FILTER]: (state, { payload }) => {
    const index = findIndex(state.filters, x => x.key === payload.key);
    const updatedFilters = [...state.filters];
    if (index !== -1) {
      updatedFilters[index].value = payload.value;
      if (typeof updatedFilters[index].value === 'string' || Array.isArray(updatedFilters[index].value)) {
        updatedFilters[index].selected = !isEmpty(updatedFilters[index].value);
      } else {
        updatedFilters[index].selected = !isEmpty(updatedFilters[index].value.type);
      }
    }

    const data = {
      ...state,
      filters: updatedFilters,
      curr_page: 1,
      allSelected: false,
      dataTable: state.dataTable.map(el => ({
        ...el,
        select: { ...el.select, value: false }
      }))
    };

    return { ...data };
  },

  [types.SET_LOOKBOOKS_ALL_FILTERS]: (state, { payload }) => {
    let updatedFilters = [...state.filters];

    payload.forEach(filter => {
      const index = findIndex(updatedFilters, x => x.key === filter.key);
      if (index !== -1) updatedFilters[index] = { ...updatedFilters[index], ...filter, selected: true };
    });

    const data = {
      ...state,
      filters: updatedFilters,
      curr_page: 1,
      queryParsed: true
    };

    return { ...data };
  },

  [types.CLEAR_LOOKBOOKS_FILTERS]: (state, { payload: { filterToUpdate, mobile } }) => {
    if (!isEmpty(filterToUpdate)) {
      const index = findIndex(state.filters, x => x.key === filterToUpdate.key);
      const updatedFilters = [...state.filters];
      if (index !== -1) {
        updatedFilters[index].value = filterToUpdate.value;
        updatedFilters[index].selected = filterToUpdate.selected;
      }

      const data = {
        ...state,
        filters: updatedFilters,
        curr_page: 1
      };

      if (!mobile) window.history.replaceState({}, '', `${window.location.pathname}${removeFromQueryString(filterToUpdate.key)}`);

      return { ...data };
    } else {
      const data = {
        ...state,
        filters: [
          ...initialState.filters
        ],
        curr_page: 1
      };

      const query = generateQueryFromString(window.location.search);

      if (query.tab) {
        if (!mobile) window.history.replaceState({}, '', `${window.location.pathname}?${queryString.stringify({ tab: query.tab })}`);
      } else {
        if (!mobile) window.history.replaceState({}, '', `${window.location.pathname}`);
      }

      return { ...data };
    }
  },

  [types.LOOKBOOKS_SET_PAGE]: (state, { payload }) => {

    const data = {
      ...state,
      curr_page: parseInt(payload) || 1,
      queryParsed: true
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};